module.exports = __webpack_public_path__ + "static/media/timelydelivery.d11a1583.jpg";